const eventStates = [
  'Setup',
  'Registration',
  'Hacking',
  'Judging',
  'PrizeSelection',
  'Completed',
];

export default eventStates;
